// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2oK_N","header":"MessagesList_header__18X1v","chat":"MessagesList_chat__2ORRF"};